import React from 'react';
import { FadeIn } from './FadeIn';
export function Services() {
  const services = [{
    id: 'implantes',
    title: 'Implantes Dentales',
    description: 'Recupera la funcionalidad y estética de tu boca con implantes de titanio premium y coronas de zirconio. Cirugía guiada por computadora para precisión milimétrica.',
    image: 'https://cdn.magicpatterns.com/uploads/69UrwEPwyGVeZ3twSuzq73/Imagen_3.jpg',
    className: 'md:col-span-2 md:row-span-2 min-h-[400px]'
  }, {
    id: 'ortodoncia',
    title: 'Ortodoncia Invisible',
    description: 'Alinea tus dientes sin brackets metálicos usando alineadores transparentes.',
    image: 'https://cdn.magicpatterns.com/uploads/5Az8q8rLDwgdHuNFFjWWpK/Imagen_4.jpg',
    className: 'md:col-span-1 md:row-span-1 min-h-[250px]'
  }, {
    id: 'estetica',
    title: 'Estética Dental',
    description: 'Carillas de porcelana ultrafinas para una sonrisa de revista en solo 2 sesiones.',
    image: 'https://cdn.magicpatterns.com/uploads/sB1hjvm6yve5JdbRS8EhcV/Imagen_8.webp',
    className: 'md:col-span-1 md:row-span-1 min-h-[250px]'
  }, {
    id: 'blanqueamiento',
    title: 'Blanqueamiento',
    description: 'Aclara hasta 4 tonos en una sola sesión con tecnología láser segura.',
    image: 'https://cdn.magicpatterns.com/uploads/f3n39XJvJhvU4DMtk9caiR/Imagen_5.jpg',
    className: 'md:col-span-1 md:row-span-1 min-h-[250px]'
  }, {
    id: 'limpieza',
    title: 'Limpieza Profunda',
    description: 'Profilaxis con ultrasonido y aeropulidor para eliminar manchas y sarro.',
    image: 'https://cdn.magicpatterns.com/uploads/bvA1VM12ecw6rBqu55fW2n/Imagen_7.jpg',
    className: 'md:col-span-1 md:row-span-1 min-h-[250px]'
  }, {
    id: 'endodoncia',
    title: 'Endodoncia',
    description: 'Tratamiento de conducto mecanizado en una sola sesión, sin dolor.',
    image: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    className: 'md:col-span-1 md:row-span-1 min-h-[250px]'
  }];
  return <section id="servicios" className="py-24 relative" data-id="element-172">
      <div className="max-w-7xl mx-auto px-6" data-id="element-173">
        <FadeIn className="mb-16" data-id="element-174">
          <h2 className="text-4xl md:text-5xl font-black text-nova-dark mb-6 tracking-tight" data-id="element-175">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-nova-gray max-w-2xl" data-id="element-176">
            Soluciones integrales con tecnología de punta. Cada tratamiento es
            personalizado para garantizar resultados excepcionales.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-fr" data-id="element-177">
          {services.map((service, index) => <FadeIn key={service.id} delay={index * 0.1} className={`group relative overflow-hidden rounded-3xl flex flex-col justify-end cursor-pointer transition-all duration-500 hover:shadow-glass-hover ${service.className}`} data-id="element-178">
              {/* Background Image for ALL cards */}
              <div className="absolute inset-0 z-0" data-id="element-179">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-180" />
                <div className="absolute inset-0 bg-gradient-to-t from-nova-dark/90 via-nova-dark/40 to-transparent" data-id="element-181"></div>
              </div>

              <div className="relative z-10 p-8 text-white" data-id="element-182">
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-183">
                  {service.title}
                </h3>
                <p className="text-gray-200 leading-relaxed max-w-md text-sm" data-id="element-184">
                  {service.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}